<template>
  <div>
    <el-badge
      :max="99"
      :value="list.length"      
      :hidden="list.length == 0"
      style="line-height: 25px;margin-top: -5px;"
      @click.native="drawerVisible=true"
    >
      <i class="el-icon-message-solid"></i>
    </el-badge>
    <el-drawer title="业务通知" :visible.sync="drawerVisible" direction="rtl">
      <div class="drawer-content" v-loading="loading">
        <el-table :data="list" :show-header="false"  style="height:100%;overflow-y: auto;">
          <el-table-column>
            <template slot-scope="scope">
              <div>{{scope.row.cerNum}}张{{scope.row.billName}}已汇总生成{{scope.row.genNum}}张凭证，凭证号：{{scope.row.cNum}}</div>
              <div>做账门店：{{scope.row.store}}</div>
              <div>做账时间：{{parseTime(scope.row.startDate, '{y}-{m}-{d}')}} ~ {{parseTime(scope.row.endDate, '{y}-{m}-{d}')}}</div>
              <div v-show="scope.row.status == -2">异常原因：{{scope.row.message}}</div>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template slot-scope="scope">
              <el-button @click="setRead(scope.row.uid)" size="mini" type="primary">已读</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="drawer-footer" v-show="list.length > 0">
          <el-button type="primary" @click="setAllRead()">全部已读</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { billsNotice, billsRead } from "@/api/certificate/certificate";
import { parseTime } from "@/utils";
import { getCurrentAccountSet } from '@/api/accountSet.js';
export default {
  name: "Notification",
  data() {
    return {
      drawerVisible: false,
      loading: false,
      list: [],
    };
  },
  computed: {},
  async created() {
    await this.getNoticeAndBind();
    setInterval(() => {
      if (getCurrentAccountSet()) {
        this.getNoticeAndBind();
      }
    }, 10 * 1000);
  },
  methods: {
    parseTime,
    async getNoticeAndBind() {
      const res = await billsNotice();
      this.list = res.data.list.filter((i) => i.status == 0 || i.status == -2);
    },
    async setRead(uid) {
      try {
        this.loading = true;
        await billsRead({ uids: [uid] });
        await this.getNoticeAndBind();
      }
      finally {
        this.loading = false;
      }
    },
    async setAllRead() {
      try {
        this.loading = true;
        await billsRead({ uids: this.list.map((i) => i.uid) });
        await this.getNoticeAndBind();
      }
      finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
>>> .el-drawer__header {
  padding: 20px;
  margin: 0px;
}
>>> .el-drawer__body {
  border-top: 1px solid #e0e0e0;
  height: calc(100% - 64px);
}
>>> .el-table::before {
  display: none;
}
.drawer-content {
  height: 100%;
  padding-bottom: 50px;
}
.drawer-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}
</style>
